module.exports = __webpack_public_path__ + "static/media/incident_category-hazmat.fc3cff4e.svg";